var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-filter" }, [
    _c("div", { staticClass: "title-container" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.filters.category) + " "),
        _vm.selectedQtyFilters > 0
          ? _c("span", [_vm._v("(" + _vm._s(_vm.selectedQtyFilters) + ")")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "icon", on: { click: _vm.collapse } }, [
        _vm._v(_vm._s(_vm.plusIcon))
      ])
    ]),
    _vm._v(" "),
    !_vm.collapsed && !_vm.isColor
      ? _c(
          "div",
          { staticClass: "checkbox-container" },
          _vm._l(_vm.filters.filters, function(categories) {
            return _c(
              "div",
              { key: categories.category, staticClass: "checkbox-button" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeFilters,
                      expression: "activeFilters"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    value: categories.tag,
                    checked: Array.isArray(_vm.activeFilters)
                      ? _vm._i(_vm.activeFilters, categories.tag) > -1
                      : _vm.activeFilters
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.activeFilters,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = categories.tag,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.activeFilters = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.activeFilters = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.activeFilters = $$c
                        }
                      },
                      function($event) {
                        return _vm.changeFilters()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(categories.value))])
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.collapsed && _vm.isColor
      ? _c(
          "div",
          { staticClass: "button-container" },
          _vm._l(_vm.filters.filters, function(categories) {
            return _c(
              "div",
              {
                key: categories.category,
                staticClass: "color-button",
                class: [
                  _vm.activeFilters.find(function(x) {
                    return x == categories.tag
                  })
                    ? "selected"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.addTag(categories.tag)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "round-color",
                  style: "background:" + _vm.getColor(categories.tag)
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(categories.value))])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }